import React from "react";
import { Button, Dialog, Stack, TextField, Typography } from "@mui/material";
import { InputSelect1 } from "../Components/Inputs/Select.jsx";
import { InputName } from "../Components/Inputs/Input_Name.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { InputCheck } from "../Components/Inputs/Input_Check.jsx";

const ProfilePreferences = ({ form, open, onClose, onChange, onSubmit, errmsg }) => {

  console.log(form)
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v
    };
    console.log(nf)
    onChange(nf);
  };

  const onChange_e = (e) => {
    onChange_any(e.target.name, e.target.value)
  }

  const mySubmit = (e) => {
    onSubmit()
  }


  return (
    <>
      <Dialog
        sx={{
          overflow: "scroll",
          "& .MuiDialog-container": {
            display: "inline-flex !important",
            //justifyContent: "flex-start",
            //alignItems: "flex-start",
            // overflow: "scroll",
            // mt: 30,
            // mx: 30,
            width: "100%",
            // minWidth: 1800,

          },
        }}
        //fullWidth={true}
        width="60%"
        maxWidth="100%"
        open={open}
        onClose={onClose}
      //disableEscapeKeyDown={true}
      >
        <Stack sx={{ mx: 4, my: 4 }} spacing={2}>
          <Stack direction="row" sx={{ mb: 6 }} spacing={2}>
            <Button variant="contained" color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={mySubmit}
            >
              Submit
            </Button>
          </Stack>

          <Stack sx={{ px: 4, py: 4 }} spacing={2}>
            <Typography sx={{ display: "flex", justifyContent: "flex-start", }} id="delete" variant="h6" gutterBottom>
              Preferences
            </Typography>
            <Stack sx={{ py: 2 }} spacing={2}>
              {form !== null && (
                <>
                  <InputName
                    name="Alias"
                    label="Alias"
                    value={form.Alias}
                    onChange={onChange_e}
                    required={false}
                    tooltip="Subscriber Name show in modified entries and other places where the name may be public"
                  />
                  <InputSelect1
                    label="Grid Display Rounding"
                    value={form.GridRound}
                    name="GridRound"
                    avail={[1, 10, 100, 1000]}
                    minWidth={200}
                    onChange={onChange_e}
                  />
                  <Stack spacing={2}>
                    <InputCheck
                      label="StartupHelp"
                      value={form.StartupHelp}
                      name="StartupHelp"
                      tooltip="Whether to show the startup help"
                      onChange={onChange_any}
                    />
                    <InputCheck
                      label="Show Ages In Joint Chart"
                      value={form.ShowAgesInJoint}
                      name="ShowAgesInJoint"
                      tooltip="Will show Ages in the Joint Charts on x-axes"
                      onChange={onChange_any}
                    />
                    <TextField
                      label="Disclaimer"
                      style={{ width: 800 }}
                      type="text"
                      multiline
                      size="small"
                      rows={6}
                      value={form.Disclaimer}
                      name="Disclaimer"
                      onChange={onChange_e}

                    />
                  </Stack>
                </>
              )}
            </Stack>


          </Stack>
        </Stack>
        <ErrorBar error={errmsg} />
      </Dialog >
    </>
  );
};
export default ProfilePreferences;
